import { inherits as _inherits, createSuper as _createSuper, createClass as _createClass, classCallCheck as _classCallCheck } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import { AccordionGroupWrapper } from '@lsg/shared';
import { createElement, Component } from 'react';

/**
 * @deprecated. Use `AccordionGroup` instead, without providing `openIndex`. If absent,
 * `AccordionGroup` will be stateful.
 */
var AccordionGroupStateful = /*#__PURE__*/function (_Component) {
  _inherits(AccordionGroupStateful, _Component);
  var _super = _createSuper(AccordionGroupStateful);
  function AccordionGroupStateful(props) {
    var _this;
    _classCallCheck(this, AccordionGroupStateful);
    _this = _super.call(this, props);
    _this.handleChange = function (open) {
      return _this.setState({
        openIndex: open
      });
    };
    _this.state = props.multiple === true ? {} : {
      openIndex: props.defaultOpenIndex
    };
    return _this;
  }
  _createClass(AccordionGroupStateful, [{
    key: "render",
    value: function render() {
      if (this.props.multiple === true) {
        return /*#__PURE__*/createElement(AccordionGroupWrapper, Object.assign({}, this.props));
      }
      var _a = this.props,
        nonMultipleProps = __rest(_a, ["defaultOpenIndex"]);
      return /*#__PURE__*/createElement(AccordionGroupWrapper, Object.assign({}, nonMultipleProps, {
        openIndex: this.state.openIndex,
        onChange: this.handleChange
      }));
    }
  }]);
  return AccordionGroupStateful;
}(Component);
AccordionGroupStateful.displayName = "Accordion.Group.Stateful";

export { AccordionGroupStateful };
